import { isFinancialManager } from "~/utils/userHelper";
import { TrackingObjectVoter } from "./TrackingObjectVoter";

export class TimeRecordVoter extends TrackingObjectVoter {
  trackingObjectClass = "TimeRecord";
  lockOptionKey = "lock_time_after_days";
  attributes = [...this.attributes, "view_source"];

  voteOnAttribute(attribute, subject, user) {
    switch (attribute) {
      case "view_source": {
        const project = this.state.projects.get(`${subject.project_id}`);
        if (!project) {
          return false;
        }

        return (
          user.class === "Owner" ||
          user.id === project.leader_id ||
          (isFinancialManager(user) && project.members.includes(user.id))
        );
      }
      default: {
        if (this.attributes.includes(attribute)) {
          return super.voteOnAttribute(attribute, subject, user);
        } else {
          throw new Error("Unknown attribute: " + attribute);
        }
      }
    }
  }
}
